import React, { FC, PropsWithChildren, ReactNode } from "react";

type Props = PropsWithChildren<{
  title?: string;
  subTitle?: string;
  actions?: ReactNode;
}>;

const Page: FC<Props> = ({ title, subTitle, actions, children }) => {
  const hasHeader = Boolean(title || subTitle || actions);
  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col py-2">
      <div className="mx-auto w-full max-w-[1200px] flex flex-1 flex-col min-h-0">
        {hasHeader && (
          <div className="flex flex-wrap items-end justify-between gap-4 mb-5 shrink-0">
            <div>
              {title && (
                <h1 className="text-[1.35rem] font-bold tracking-tight text-slate-900 leading-tight">
                  {title}
                </h1>
              )}
              {subTitle && (
                <p className="text-sm text-slate-500 mt-1">{subTitle}</p>
              )}
            </div>
            {actions && (
              <div className="flex items-center gap-2 shrink-0">{actions}</div>
            )}
          </div>
        )}
        <div className="flex flex-1 flex-col min-h-0 overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Page;
